import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Form
 */
export class UploadResponseDraftValueObject extends ValueObject {
  /**
   * @param {Object}  data
   * @param {String} data.url
   */
}
